export { default } from './TrailCard';
